/* eslint-disable @typescript-eslint/camelcase */
import i18n from "@/i18n";

export const getHangingStyle = (days?: number) => {
  if (days == null) return { backgroundColor: "#F5F5F5", color: "#4D4D4D" };

  if (days >= 7) return { backgroundColor: "#FF0000", color: "#FFFFFF" };
  if (days === 6) return { backgroundColor: "#FCECE7", color: "#CD4425" };
  if (days === 5) return { backgroundColor: "#FFEB9F", color: "#F09035" };
  if (days <= 4) return { backgroundColor: "#EAFCFF", color: "#47A1BC" };

  return { backgroundColor: "#F5F5F5", color: "#4D4D4D" };
};

export const getHangingLabel = (days?: number) => {
  const t = i18n.global.t;
  return days != null
    ? days < 7
      ? `${days} ${t("dashboard.hanging.dayUnit")}`
      : String(t("dashboard.hanging.day7Plus"))
    : "-";
}

export const getStatusStyle = (status?: string) => {
  const styles: Record<string, { bg: string; color: string }> = {
    belum_ditemukan: { bg: "#FEE8E8", color: "#B82025" },
    ditemukan_konsol: { bg: "#D8EEFB", color: "#2468F6" },
    ditemukan_pos: { bg: "#E9E7FD", color: "#4F46A4" }
  };

  const { bg, color } = styles[status ?? ""] || {
    bg: "#F5F5F5",
    color: "#4D4D4D"
  };
  return { backgroundColor: bg, color };
};

export const getStatusLabel = (status?: string) => {
  const t = i18n.global.t;
  const labels: Record<string, string> = {
    belum_ditemukan: String(t("dashboard.hanging.statusNotFound")),
    ditemukan_konsol: String(t("dashboard.hanging.statusFoundConsole")),
    ditemukan_pos: String(t("dashboard.hanging.statusFoundPos"))
  };

  return labels[status ?? ""] || "-";
};
